// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 133,
  argument: "An exhortation to praise God continually.",
  verses: [
    { n: 1, text: "A gradual canticle. Behold now bless ye the Lord, all ye servants of the Lord: Who stand in the house of the Lord, in the courts of the house of our God." },
    { n: 2, text: "In the nights lift up your hands to the holy places, and bless ye the Lord." },
    { n: 3, text: "May the Lord out of Sion bless thee, he that made heaven and earth." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Canticle. David composed it for the Levites going on duty, (Haydock) or Solomon for the dedication of the temple. The people might use it on the last day of the three great festivals; or the Levites are exhorted to watch carefully. They may excite each other, (", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "; Calmet) as all Christians should do, 1 Peter ii. 9. (Berthier) — In the courts, &c., seems to be taken from Psalm cxxxiv. 2., (Calmet) as it is not in Hebrew. (St. Hilary) — The court of the people was divided for the men and women, and perhaps there was a separate place for the priests, and for the Levites, in the court of allotted to them, where the latter kept watch.", attribution: "Calmet" }
    ] },
    { verse: 3, notes: [
      { text: "Thee. \"A Levite on guard answers the cantor,\" (Houbigant) or the priests say this to the people, when they were departing home, Numbers vi. 23. (Calmet) — Earth. All things were made to praise God.", attribution: "Worthington" }
    ] },
  ],
};

export default chapter;
